import apiInstance from "@/lib/axios";

export const LoginApi = async (
  email: string,
  password: string,
  captchaToken?: string,
  visitorId?: string,
) => {
  try {
    const response = await apiInstance.post("/api/auth/login", {
      email,
      password,
      captchaToken,
      visitorId,
    });

    console.log("LoginApi response:", response.data); // Log the response data for debugging
    return response;
  } catch (error: any) {
    console.error("Error during login:", error);

    if (error.response?.status === 401) {
      throw new Error("Invalid email or password");
    }
    if (error.response?.status === 429) {
      throw new Error("Too many requests. Please try again later.");
    }
    // 423: the account is valid but locked (a Tech Performance plan that has ended). Pass the
    // server's message and code through so the sign-in screen can say why.
    if (error.response?.status === 423) {
      const locked = new Error(
        error.response?.data?.error || "This account is locked. Contact our support team.",
      ) as Error & { code?: string };
      locked.code = error.response?.data?.code || "account_locked";
      throw locked;
    }

    throw new Error("Login failed");
  }
};

export const VerifyMfaCodeApi = async (ticket: string, code: string) => {
  const response = await apiInstance.post("/api/auth/mfa/verify", { ticket, code });
  return response;
};

export const ResendMfaCodeApi = async (ticket: string) => {
  const response = await apiInstance.post("/api/auth/mfa/resend", { ticket });
  return response;
};
export const RegisterApi = async (userName: string, email: string, password: string) => {
  try {
    const response = await apiInstance.post("/api/auth/register", {
      userName,
      email,
      password,
    });
    return response;
  } catch (error: any) {
    console.error("Error during login:", error);

    if (error.response?.status === 401) {
      throw new Error("Invalid email or password");
    }

    throw new Error("Login failed");
  }
};
export const UpdateUsernameApi = async (userId: string, userName: string) => {
  try {
    const response = await apiInstance.post("/api/auth/update-username", {
      userId,
      userName,
    });
    return response;
  } catch (error: any) {
    console.error("Error during update:", error);

    if (error.response?.status === 401) {
      throw new Error("Invalid Username");
    }

    throw new Error("Update failed");
  }
};

export const ResetLink = async (email: string) => {
  try {
    const response = await apiInstance.post("/api/auth/reset-link", {
      email,
    });
    return response;
  } catch (error: any) {
    console.error("Error during update:", error);
    if (error.response?.status === 401) {
      throw new Error(error.response.data.error || "Invalid current password");
    }
    throw new Error(error.response.data.error || "Update failed");
  }
};
export const VerifyToken = async (token: string) => {
  try {
    const response = await apiInstance.get("/api/auth/reset-link", {
      params: { token },
    });
    return response;
  } catch (error: any) {
    console.error("Error during update:", error);
    if (error.response?.status === 401) {
      throw new Error(error.response.data.error || "Invalid current password");
    }
    throw new Error("Update failed");
  }
};





